export const getUserInfo = () => {
  try {
    return JSON.parse(localStorage.getItem('userInfo') || '{}') || {}
  } catch (error) {
    return {}
  }
}

export const getFacilityId = () => getUserInfo()?.facility?.id

// Main facility followed by its branches (nested under `facilities`)
export const buildFacilitiesList = (facility) => {
  if (!facility) return []
  const { facilities: branches = [], ...main } = facility
  return [main, ...(branches || [])]
}

// Keeps a flat `facilities` list on userInfo so the navbar can switch between
// the main facility and its branches; `facility` stays the selected one.
export const normalizeUserInfo = (data, fallbackFacility) => {
  if (!data) return data
  let facilities = Array.isArray(data.facilities) && data.facilities.length
    ? data.facilities
    : buildFacilitiesList(data.facility)
  if (facilities.length < 2 && fallbackFacility) {
    facilities = buildFacilitiesList(fallbackFacility)
  }
  return { ...data, facilities }
}

export const switchFacility = (facilityId) => {
  const userInfo = getUserInfo()
  const facility = (userInfo.facilities || []).find(item => item.id === facilityId)
  if (!facility) return false
  localStorage.setItem('userInfo', JSON.stringify({ ...userInfo, facility }))
  return true
}
